<!--
 * @Author: M.D.
 * @Date: 2019-12-24 13:32:16
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="prd-qyfw-w">
    <!-- filter -->
    <div class="qypx-filter-w">
      <category-filter @filterInfo='getDataByFilter'></category-filter>
      <gds-list :outerFilter="headFilter"></gds-list>
    </div>
  </div>
</template>

<script>
import CategoryFilter from '@/components/category-filter'
// import GdsListRow from '@/components/gds-list-row'
// import GdsListGrid from '@/components/gds-list-grid'
import GdsList from '@/components/gds-list'
import { mapGetters } from 'vuex'

export default {
  props: {

  },
  data () {
    return {
      headFilter: {
        curLoc: this.curLoc
      }
    }
  },
  computed: {
    ...mapGetters(['curLoc'])
  },
  created () {
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {
    curLoc (v) {
      let f = this._.clone(this.headFilter)
      f.curLoc = v
      this.getDataByFilter(f)
    }
  },
  methods: {
    getDataByFilter (f) {
      if (!this._.isEmpty(f)) {
        this.headFilter = f
      }
    }
  },
  components: {
    CategoryFilter, GdsList
  }
}
</script>

<style lang="stylus" scpoed>
.prd-qyfw-w{
  width:1200px;
  margin:auto;
}
</style>
